
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M10 19A9 9 0 1 1 10.001.999 9 9 0 0 1 10 19zm0-16.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15zm-.75 8.75c0 .138.112.25.25.25h1a.25.25 0 0 0 .25-.25v-5.5a.25.25 0 0 0-.25-.25h-1a.25.25 0 0 0-.25.25v5.5zm0 3c0 .138.112.25.25.25h1a.25.25 0 0 0 .25-.25v-1a.25.25 0 0 0-.25-.25h-1a.25.25 0 0 0-.25.25v1z"}})])
          )
        }
      }
    